import { Loader2Icon } from 'lucide-react';
import type { ReactNode } from 'react';

import { ApiRequestError } from '@/lib/api';

export function MasterDataListState({
  pending,
  pendingLabel,
  error,
  errorLabel,
  empty,
  emptyLabel,
  children,
}: {
  pending: boolean;
  pendingLabel: string;
  error: unknown;
  errorLabel: string;
  empty: boolean;
  emptyLabel: string;
  children: ReactNode;
}) {
  if (pending) {
    return (
      <p className="flex items-center gap-2 text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        {pendingLabel}
      </p>
    );
  }
  if (error) {
    return (
      <p role="alert" className="text-sm text-destructive">
        {error instanceof ApiRequestError ? error.message : errorLabel}
      </p>
    );
  }
  if (empty) {
    return <p className="text-sm text-muted-foreground">{emptyLabel}</p>;
  }
  return children;
}
